import { render, staticRenderFns } from "./bloodPressure.vue?vue&type=template&id=a657aeb2&scoped=true"
import script from "./bloodPressure.vue?vue&type=script&lang=js"
export * from "./bloodPressure.vue?vue&type=script&lang=js"
import style0 from "./bloodPressure.vue?vue&type=style&index=0&id=a657aeb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a657aeb2",
  null
  
)

export default component.exports